import React, { useState } from 'react'
import { InboxOutlined } from '@ant-design/icons'
import { Upload, message, UploadFile, UploadProps } from 'antd'
import type { UploadRequestOption } from 'rc-upload/lib/interface'
import { uploadSlipToBackend } from '../../../services/gcs-upload.service'

const { Dragger } = Upload

export const UploadImg = ({
    onUploadImgSuccess,
    productID,
    onLoadingChange,
}: {
    onUploadImgSuccess: (url: string, id: string) => void
    onUploadImgDelete?: () => void
    productID: string
    onLoadingChange?: (isLoading: boolean) => void
}): JSX.Element => {
    const [imageUrl, setImageUrl] = useState('')
    const [previewImageContent, setPreviewImageContent] = useState<UploadFile[]>([])

    const urlParams = new URLSearchParams(location.search)
    const refIdParams = urlParams.get('refId')
    const [refId, setRefId] = useState(refIdParams ?? '')

    const customRequest = async (options: UploadRequestOption) => {
        const { file, onSuccess, onError } = options
        const f = file as File

        onLoadingChange?.(true)
        try {
            const result = await uploadSlipToBackend(
                f,
                productID,
                refId,
                // progress isn't surfaced to the Ant Design fileList here because
                // the Dragger shows its own indicator; onProgress wires up fine:
                (percent) => {
                    // Ant Design's internal progress update
                    options.onProgress?.({ percent } as unknown as ProgressEvent)
                }
            )

            setRefId(result.id)
            setImageUrl(result.url)
            onUploadImgSuccess(result.url, result.id)
            message.success(`${f.name} อัปโหลดไฟล์เสร็จสิ้น`)
            onSuccess?.(result)
        } catch (err) {
            const msg = (err as Error).message
            message.error(`${f.name} อัปโหลดไฟล์ล้มเหลว: ${msg}`)
            onError?.(err as Error)
        } finally {
            onLoadingChange?.(false)
        }
    }

    const uploadProps: UploadProps = {
        name: 'slip',
        multiple: false,
        accept: 'image/jpg, image/png, image/jpeg',
        maxCount: 1,
        customRequest,
        fileList: previewImageContent,
        onChange(info) {
            const { status } = info.file
            if (status === 'done' && info.file.response) {
                setImageUrl(info.file.response.url)
            }
            setPreviewImageContent(info.fileList)
        },
        onPreview: async (file: UploadFile) => {
            window.open(file.url || file.response?.url, '_blank')
        },
    }

    return (
        <Dragger {...uploadProps} style={{ width: '100%', height: '200px' }}>
            {previewImageContent.length === 0 && (
                <>
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">เลือกไฟล์หรือลากมาที่นี่</p>
                    <p className="ant-upload-hint">รองรับ PNG, JPG, JPEG</p>
                </>
            )}
            {previewImageContent.length > 0 && (
                <img
                    src={imageUrl}
                    alt="Preview"
                    style={{ objectFit: 'contain', width: '100%', height: '200px' }}
                />
            )}
        </Dragger>
    )
}
